export default {
  General: 0, // Không chọn,
  // Science: 1,// Đặc thù Bộ khoa học,
  Statistic: 2, // Đặc thù Tổng cục thống kê,
  // VAAC_US_CDC: 3,// VAAC-US.CDC,
  // NamDinh: 4,// Đặc thù Nam Định,
  // DongNai: 5,// Đặc thù Đồng Nai,
  // CompleteAutonomy: 6,// Đặc thù các đơn vị tự chủ hoàn toàn,
  // SYTBacNinh: 7,// Đặc thù Sở y tế Bắc Ninh,
  // BoLDTB_XH: 8,// Đặc thù Bộ Lao động - Thương binh và xã hội,
  // DangAudit: 9,// Đặc thù Kế toán Đảng,
  StateAudit: 10, // Đặc thù Kiểm toán Nhà nước,
  SGDHaiDuong: 11, // Đặc thù Sở giáo dục Hải Dương,
  // STCLongAn: 12,// Đặc thù Sở tài chính Long An,
  // BoTTTT: 13,// Đặc thù Bộ thông tin truyền thông,
  // STCKhanhHoa: 14,// Đặc thù Sở tài chính Khánh Hòa
};
